exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-gallery[data-v-34877230]{text-align:center;width:100%;height:100%;display:-ms-flexbox;display:flex;min-height:99vw}@media only screen and (min-width: 768px){.media-gallery[data-v-34877230]{min-height:inherit}}.media-gallery--loaded[data-v-34877230]{background-image:none}", ""]);

// exports
